import React, {Component} from 'react';
import OrderFailImage from "../../../../../assets/img/orderFailImage.png";
import {Redirect} from "react-router-dom";
import OrderCancelledImage from "../../../../../assets/img/cancelledImg.png";
import ContactUs from "../../../SiteRoot/Navigation/ContactUs/ContactUs";
import {BASE_URL} from "../../../../../configuration";

class StripeFailComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            redirect: false,

        };
        this.redirectToHome = this.redirectToHome.bind(this);
        this.showContactUs = this.showContactUs.bind(this);
        this.redirectToMyPage = this.redirectToMyPage.bind(this);

    }
    componentDidMount() {

    }
    redirectToHome = () => {
        this.setState({
            redirect : true,
        })
    };
    showContactUs = () => {
        let elmnt = document.getElementById("sub-title-span-resp");

        if(elmnt !== null){
            elmnt.click();
        }
    };
    componentWillUnmount() {
        window.scrollTo(0,0);
        localStorage.removeItem("stp");
        localStorage.removeItem("ppe");
        localStorage.removeItem("roc");
    }
    redirectToMyPage = () => {
        //window.open(BASE_URL + 'order/all', '_self')
        this.setState({
            redirect : true,
        })
    };

    render() {
        let userId = null;
        if(JSON.parse(localStorage.getItem("stp")) !== null){
             userId = JSON.parse(localStorage.getItem("stp")).userId;
            localStorage.setItem("ui", userId);
        }else {
            userId = localStorage.getItem("ui");
        }

        const {redirect} = this.state;

        if (redirect) {
            //return <Redirect to='/'/>;
            return <Redirect to='/order/all'/>;
        }


        return (
            <div className="text-center success-ui-message-div">
                <img src={OrderCancelledImage} alt="キャンセルされました" className="payment-failcomp-resp-img"/>
                <h3 className="cancelled-text-content">支払いはキャンセルされました。</h3><br/>
                <h5>ご注文に関して、ご質問やご不明な点がございましたら</h5>
                <h5 className="cancelled-text-line"><span hidden={true}><ContactUs userId={userId}/></span><span className="cancelled-inquiry-form" onClick={this.showContactUs}>お問い合わせフォーム</span>よりご連絡を頂けますようお願いいたします。</h5><br/>
                <div><button onClick={this.redirectToMyPage} className="btn btn-success btn-color-payment-mobile">マイページへ</button></div>
            </div>
        );
    }
}

export default StripeFailComponent;



// WEBPACK FOOTER //
// ./src/components/Site/Order/OrderConfirmationBottom/StripeComponents/StripeFailComponent.js